module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/hlukovaMapa-5b9a5721eb7ed3a08afb55db2cf89983.svg";